shadow$provide[256] = function(require,module,exports) {
var require$_DOT__SLASH_html_DOT_js = require("./html.js");
var require$_DOT__SLASH_dom_DOT_js = require("./dom.js");
require.exportCopy(module, require$_DOT__SLASH_html_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_dom_DOT_js);

};